import localeProvider from 'element-ui/lib/locale';
import ElButton from './Button';
import ElButtonGroup from './ButtonGroup';
import ElInput from './Input';
import ElCheckbox from './Checkbox';
import ElDialog from './Dialog';
import ElIcon from './Icon';
import ElForm from './Form';
import ElFormItem from './FormItem';
import ElTable from './Table';
import ElTableColumn from './TableColumn';
import ElTabs from './Tabs';
import ElTabPane from './TabPane';
import ElSwitch from './Switch';
import ElRadio from './Radio';
import ElRadioGroup from './RadioGroup';
import ElRadioButton from './RadioButton';
import ElSelect from './Select';
import ElOption from './Option';
import ElAlert from './Alert';
import ElTag from './Tag';
import ElTooltip from './Tooltip';
// import ElDatePicker from './DatePicker';
import ElDropdown from './Dropdown';
import ElDropdownItem from './DropdownItem';
import ElDropdownMenu from './DropdownMenu';
import ElProgress from './Progress';
import ElPopover from './Popover';
import ElRate from './Rate';
import ElPagination from './Pagination';
import ElLoading from './Loading';
import { MessageBox as ElMessageBox } from './MessageBox';
import { Message as ElMessage } from './Message';
import ElSlider from './Slider';
import ElSteps from './Steps';
import ElStep from './Step';
import ElCheckboxGroup from './CheckboxGroup';
import ElCascader from './Cascader';
import ElScrollbar from './ElScrollbar';
import notification from './notification';
import ElBadge from './Badge';
import ElTransfer from './Transfer';
import Collapse from './Collapse';
import CollapseItem from './CollapseItem';
import i18n from '../../locales/index';

localeProvider.i18n(key => i18n.t(key));

export {
  ElButton,
  ElButtonGroup,
  ElInput,
  ElCheckbox,
  ElDialog,
  ElIcon,
  ElForm,
  ElFormItem,
  ElTable,
  ElTableColumn,
  ElTabs,
  ElTabPane,
  ElSwitch,
  ElRadio,
  ElRadioGroup,
  ElRadioButton,
  ElSelect,
  ElOption,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElMessageBox,
  ElMessage,
  // ElDatePicker,
  ElLoading,
  ElProgress,
  ElPopover,
  ElRate,
  ElPagination,
  ElAlert,
  ElTag,
  ElTooltip,
  ElSlider,
  ElSteps,
  ElStep,
  ElCheckboxGroup,
  ElCascader,
  ElScrollbar,
  ElBadge,
  ElTransfer,
  Collapse,
  CollapseItem,
  notification,
};
